<template>
  <v-container
    v-if="!uiStore.errorMsg"
    class="text-grey-darken-1 mt-4 py-0"
    max-width="1200"
  >
    <InvoiceTracking
  /></v-container>
</template>

<script setup lang="ts">
import { useUiStore } from "@/stores/uiStore";

definePage({
  meta: {
    adminBlocked: true,
  },
});

const uiStore = useUiStore();
</script>
